import { Gender, GenderLabel, TableTitles } from "@/constants";
import { cn } from "@/libs/cn";
import { Badge, Button, Space, TableProps, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import { AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router";
import { AntdTable } from "../common";
import { GenderTag } from "./GenderTag";

type RoomTableProps = {
	dataSource: TableProps<Room>["dataSource"];
	currentPage: number;
} & Omit<TableProps<Room>, "dataSource" | "columns">;

export function RoomTable({
	dataSource,
	currentPage,
	...props
}: RoomTableProps) {
	const columns: ColumnsType<Room> = [
		{
			title: TableTitles.No,
			key: "no",
			render: (_, __, index) => (currentPage - 1) * 10 + index + 1,
		},
		{
			title: "အခန်းအမည်",
			dataIndex: "name",
			key: "name",
		},
		{
			title: "Gender",
			dataIndex: "gender",
			key: "gender",
			render: (_, record) => <GenderTag {...record} />,
			filters: Object.values(Gender)
				.filter((value) => value !== Gender.UNKNOWN)
				.map((value) => ({
					text: GenderLabel[value as Gender],
					value: value,
				})),
			onFilter(value, record) {
				return record.gender === value;
			},
		},
		{
			title: TableTitles.retreat_name,
			dataIndex: "meditationEvent",
			key: "meditationEvent",
			render: (event: MeditationRetreat) =>
				event ? (
					<h2>
						{event.level.name} - {event.title}{" "}
					</h2>
				) : (
					"-"
				),
		},
		{
			title: "Status",
			dataIndex: "meditationEvent",
			render: (event: MeditationRetreat) => {
				const isAvailable = !event;
				return (
					<Tag
						color={isAvailable ? "green" : "red"}
						icon={
							<Badge
								status={isAvailable ? "success" : "error"}
								className="mr-1.5!"
							/>
						}
					>
						{isAvailable ? "Available" : "Unavailable"}
					</Tag>
				);
			},
		},
		{
			title: "Occupancy",
			dataIndex: "id",
			key: "occupancy",
			render: (_, { count, maxiCount }) => (
				<article
					className={cn(
						"text-success! rounded-lg! font-poppins h-8 px-2 flex items-center justify-center",
						{
							"text-danger! border-danger!": count === maxiCount,
						},
					)}
				>
					{count} / {maxiCount}
				</article>
			),
		},
		{
			title: "Detail",
			dataIndex: "id",
			key: "actions",
			render: (id) => (
				<Space>
					<Link to={`/rooms/${id}/detail`}>
						<Button
							icon={<AiOutlineEye />}
							type="link"
							title="View Detail"
							className="text-base!"
						/>
					</Link>
				</Space>
			),
			align: "center",
			fixed: "right",
		},
	];

	return (
		<>
			<AntdTable
				dataSource={dataSource}
				columns={columns}
				pagination={false}
				{...props}
			/>
		</>
	);
}
